import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Card,
  Upload,
  Modal,
  DatePicker,
  Select,
  Typography,
} from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import Post from "../services/Post";
import { CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import indiaData from "../assets/state-dist.json";
import OTPInput from "otp-input-react";

const UserDetailsForm = () => {
  const [profile, setProfile] = useState("");
  const [aadharFront, setAadharFront] = useState("");
  const [aadharBack, setAadharBack] = useState("");
  const [panPic, setPanPic] = useState("");
  const [bankDoc, setBankDoc] = useState("");
  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [isDistrictDisabled, setIsDistrictDisabled] = useState(true);
  const [otpId, setOtpId] = useState();
  const [OTP, setOTP] = useState();
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const user = JSON.parse(localStorage.getItem("user"));
  const refer_code = searchParams.get("refer");
  console.log("user", user);

  const eighteenYearsAgo = moment().subtract(18, "years");

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsPinModalOpen(false);
  };

  const validateAge = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Please enter Date of birth!"));
    }
    const age = moment().diff(value, "years");
    if (age < 18) {
      return Promise.reject(new Error("You must be 18"));
    }
    return Promise.resolve();
  };

  const handleStateChange = (value) => {
    const selectedState = indiaData.states.find((s) => s.state === value);
    if (selectedState) {
      setDistrictOptions(selectedState.districts);
      setIsDistrictDisabled(false);
    } else {
      setDistrictOptions([]);
      setIsDistrictDisabled(true);
    }
  };

  const handleUpdateProfile = async () => {
    form
      .validateFields()
      .then((values) => {
        setPendingFormData(values); // store form values
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });

    const res = await Post.UpdateSendOTP();
    if (res.error) {
      message.error("Something went wrong!");
    } else {
      setOtpId(res.id);
      setIsPinModalOpen(true);
    }
  };

  const handleOtpSubmit = () => {
    if (!OTP || OTP.length !== 6) {
      message.error("Please enter a valid 6-digit OTP.");
      return;
    }

    if (pendingFormData) {
      onFinish(pendingFormData); // call onFinish with saved form values
    }
  };

  const onFinish = (values) => {
    if (values.password !== values.confirm_password) {
      message.error("Passwords do not match!");
      return;
    }
    const formattedDob = values.dob ? values.dob.format("YYYY-MM-DD") : null;
    console.log("Form Data Submitted:", values);
    const formData = {
      firstName: values.firstName,
      lastName: values.lastName,
      fatherName: values.fatherName,
      motherName: values.motherName,
      dob: formattedDob,
      email: values.email,
      profile, // from setProfile hook
      aadharFront, // from setAadharFront hook
      aadharBack, // from setAadharBack hook
      panPic, // from setPanPic hook
      bankDoc, // from setBankDoc hook
      alternet_mobile: values.alternet_mobile,
      address: values.address,
      dist: values.dist,
      state: values.state,
      pincode: values.pincode,
      aadharNo: values.aadharNo,
      panNo: values.panNo,
      bankName: values.bankName,
      accountNo: values.accountNo,
      ifsc: values.ifsc,
      nomineeName: values.nomineeName,
      nomineeRelation: values.nomineeRelation,
      nomineeAge: values.nomineeAge,
      refer_code: values.refer_code,
      otp: OTP,
      otpId,
    };

    Post.UpdateUserProfile(formData).then((res) => {
      console.log(res);

      if (res.error) {
        message.error(res.error);
      } else {
        const user = JSON.parse(localStorage.getItem("user"));

        // Update the relevant fields
        const updatedUser = {
          ...user, // Spread the existing user data
          name: res.data.name, // Update only the necessary fields
          email: res.data.email,
          alternet_mobile: res.data.alternet_mobile,
          password: res.data.password,
        };

        // Store the updated user data in localStorage
        localStorage.setItem("user", JSON.stringify(updatedUser));
        message.success("User details successfully updated!");
        navigate("/user/security");
      }
    });
  };

  const normFile = (e, setFile) => {
    console.log("Upload event:", e);

    const fileList = Array.isArray(e) ? e : e?.fileList;
    const file = fileList?.[fileList.length - 1]?.originFileObj;

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        console.log("Base64:", base64String);
        setFile(base64String);
      };
    }

    return file ? [file] : [];
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
      <Col xs={22} sm={16} md={16} lg={10}>
        <Card>
          <Form
            form={form}
            name="user-details-form"
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              firstName: user.name,
              lastName: user.last_name,
              fatherName: user.father_name,
              motherName: user.mother_name,
              dob: moment(user.dob).isValid()
                ? moment(user.dob)
                : eighteenYearsAgo,
              email: user.email,
              mobile: user.mobile,
              alternet_mobile: user.alternet_mobile,
              address: user.address,
              dist: user.distict,
              state: user.state,
              pincode: user.pincode,
              aadharNo: user.aadhar_no,
              panNo: user.pan_no,
              bankName: user.bank_name,
              accountNo: user.account_no,
              ifsc: user.ifsc,
              nomineeName: user.nominee_name,
              nomineeRelation: user.nominee_relation,
              nomineeAge: user.nominee_age,
              refer_code: refer_code || user.parent_code,
            }}
          >
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter your first name" />
            </Form.Item>

            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter your last name" />
            </Form.Item>

            <Form.Item
              label="Father Name"
              name="fatherName"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter your father name" />
            </Form.Item>

            <Form.Item
              label="Mother Name"
              name="motherName"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter your mother name" />
            </Form.Item>

            <Form.Item
              label="DOB"
              name="dob"
              rules={[{ validator: validateAge }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                disabledDate={(current) =>
                  current && current > eighteenYearsAgo
                }
                placeholder="Select your date of birth"
              />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true }, { type: "email" }]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item label="Mobile" name="mobile">
              <Input disabled />
            </Form.Item>

            <Form.Item
              label="Alternate Mobile (Optional)"
              name="alternet_mobile"
            >
              <Input placeholder="Enter alternate mobile number" />
            </Form.Item>

            <Form.Item
              label="Address"
              name="address"
              rules={[
                { required: true, message: "Please enter your address!" },
              ]}
            >
              <Input placeholder="Enter your address" />
            </Form.Item>

            <Form.Item
              label="State"
              name="state"
              rules={[{ required: true, message: "Please select your state!" }]}
            >
              <Select
                placeholder="Select your state"
                onChange={handleStateChange}
                showSearch
                optionFilterProp="children"
              >
                {indiaData.states.map((state) => (
                  <Select.Option key={state.state} value={state.state}>
                    {state.state}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="District"
              name="dist"
              rules={[
                { required: true, message: "Please select your district!" },
              ]}
            >
              <Select
                placeholder="Select your district"
                disabled={isDistrictDisabled}
                showSearch
                optionFilterProp="children"
              >
                {districtOptions.map((district) => (
                  <Select.Option key={district} value={district}>
                    {district}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* <Form.Item label="Dist" name="dist">
              <Input placeholder="Enter your District" />
            </Form.Item>

            <Form.Item label="State" name="state">
              <Input placeholder="Enter your State" />
            </Form.Item> */}

            <Form.Item
              label="Pincode"
              name="pincode"
              rules={[
                { required: true, message: "Please enter your pincode!" },
              ]}
            >
              <Input placeholder="Enter your Pincode" />
            </Form.Item>

            <Form.Item
              label="Aadhar Number"
              name="aadharNo"
              rules={[
                { required: true, message: "Please enter your Aadhar number!" },
                {
                  pattern: /^\d{12}$/,
                  message: "Aadhar number must be exactly 12 digits!",
                },
              ]}
            >
              <Input placeholder="Enter your Aadhar number" maxLength={12} />
            </Form.Item>

            <Form.Item
              label="PAN Number"
              name="panNo"
              rules={[
                { required: true, message: "Please enter your pan number!" },
              ]}
            >
              <Input placeholder="Enter PAN number" />
            </Form.Item>

            <Form.Item
              label="Bank Name"
              name="bankName"
              rules={[
                { required: true, message: "Please enter your bank name!" },
              ]}
            >
              <Input placeholder="Enter Bank name" />
            </Form.Item>

            <Form.Item
              label="Account Number"
              name="accountNo"
              rules={[
                { required: true, message: "Please enter your account no!" },
              ]}
            >
              <Input placeholder="Enter Account number" />
            </Form.Item>

            <Form.Item
              label="IFSC Code"
              name="ifsc"
              rules={[
                { required: true, message: "Please enter your ifsc code!" },
              ]}
            >
              <Input placeholder="Enter IFSC Code" />
            </Form.Item>

            <Form.Item
              label="Nominee Name"
              name="nomineeName"
              rules={[
                { required: true, message: "Please enter your Nominee!" },
              ]}
            >
              <Input placeholder="Enter Nominee Name" />
            </Form.Item>

            <Form.Item
              label="Nominee Relation"
              name="nomineeRelation"
              rules={[
                {
                  required: true,
                  message: "Please enter your Nominee Relation!",
                },
              ]}
            >
              <Input placeholder="Enter Nominee Relation" />
            </Form.Item>

            <Form.Item
              label="Nominee Age"
              name="nomineeAge"
              rules={[
                { required: true, message: "Please enter your Nominee Age!" },
              ]}
            >
              <Input placeholder="Enter Nominee Age" />
            </Form.Item>

            {/* Upload Fields */}
            <div className="form_upload">
              <Form.Item
                label="Upload Profile Pic"
                name="profile"
                valuePropName="fileList"
                getValueFromEvent={(e) => normFile(e, setProfile)}
              >
                <Upload
                  listType="picture-card"
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                >
                  {form.getFieldValue("profile")?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined /> Upload
                    </div>
                  )}
                </Upload>
              </Form.Item>

              <Form.Item
                label="Upload Aadhar Front"
                name="aadharFront"
                valuePropName="fileList"
                getValueFromEvent={(e) => normFile(e, setAadharFront)}
              >
                <Upload
                  listType="picture-card"
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                >
                  {form.getFieldValue("aadharFront")?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined /> Upload
                    </div>
                  )}
                </Upload>
              </Form.Item>

              <Form.Item
                label="Upload Aadhar Back"
                name="aadharBack"
                valuePropName="fileList"
                getValueFromEvent={(e) => normFile(e, setAadharBack)}
              >
                <Upload
                  listType="picture-card"
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                >
                  {form.getFieldValue("aadharBack")?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined /> Upload
                    </div>
                  )}
                </Upload>
              </Form.Item>
            </div>
            <div className="form_upload">
              <Form.Item
                label="Upload PAN Card"
                name="panPic"
                valuePropName="fileList"
                getValueFromEvent={(e) => normFile(e, setPanPic)}
              >
                <Upload
                  listType="picture-card"
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                >
                  {form.getFieldValue("panPic")?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined /> Upload
                    </div>
                  )}
                </Upload>
              </Form.Item>

              <Form.Item
                label="Upload Bank Document"
                name="bankDoc"
                valuePropName="fileList"
                getValueFromEvent={(e) => normFile(e, setBankDoc)}
              >
                <Upload
                  listType="picture-card"
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                >
                  {form.getFieldValue("bankDoc")?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined /> Upload
                    </div>
                  )}
                </Upload>
              </Form.Item>
            </div>

            <Form.Item label="Referral Code (Optional)" name="refer_code">
              <Input placeholder="Enter referral code" />
            </Form.Item>

            {user.is_submitted == '1' ? (
              <Form.Item>
                <Button
                  type="primary"
                  onClick={handleUpdateProfile}
                  style={{
                    backgroundColor: "#a6cc43",
                    borderColor: "#a6cc43",
                    color: "#fff",
                  }}
                >
                  Update
                </Button>
              </Form.Item>
            ) : (
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    backgroundColor: "#a6cc43",
                    borderColor: "#a6cc43",
                    color: "#fff",
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            )}
          </Form>

          <Modal
            title="Update Profile"
            open={isPinModalOpen}
            onOk={handleOtpSubmit}
            onCancel={handleCancel}
          >
            <Typography.Title className="font-regular text-muted" level={5}>
              Enter 6 digits OTP sent to your phone number
            </Typography.Title>
            <div className="otp-form">
              <label>Enter OTP</label>
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={6}
                otpType="number"
                disabled={false}
                secure
                style={{ marginBottom: 20, padding: 10 }}
              />
            </div>
          </Modal>
        </Card>
      </Col>
    </Row>
  );
};

export default UserDetailsForm;